
define('text!widgets/casumo2/view.html',[],function () { return '<div class="casumo-progress-container container-casumo"\n     data-bind="image: casumo().images.sumo">\n</div>\n';});

